import { Layout, Spin, message, Upload, Button, Badge, Dropdown, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import UpdateEmployeeInfo from './UpdateEmployeeInfo';
import UpdateEmploymentInfo from './UpdateEmploymentInfo';
import UpdateUserInfo from './UpdateUserInfo';
import { downloadEmpCardReq, downloadReportReq, getEmploymentHistoryReq, getProfileCardByEmploymentIdReq, uploadPhotoReq } from '../requests';
import { downloadFullEmploymentExitReport } from '../fullEmploymentExitReportDownload';
import { makeRequestStateless, handleDownloadFile, makeRequest } from "@utils/helpers";
import IndexContacts from '@mods/employeeManagement/contacts/IndexContacts';
import UpdatePayrollPolicy from './UpdatePayrollPolicy';
import { ModalComponent, SectionTabs } from "@comps/components"
//import IndexAssets from '../../assets/IndexAssets';
import IndexRelatives from '../../relatives/IndexRelatives';
import IndexExperience from '../../experiences/IndexExperience';
import IndexAddresses from '../../addresses/IndexAddresses';
import IndexEducations from '../../educations/IndexEducations';
import IndexBanks from '../../bank/IndexBanks';
import IndexDocuments from '../../documents/IndexDocuments';
import IndexCompanyTimeSheet from '../../../attendanceManagement/companyTimeSheet/IndexCompanyTimeSheet';
import IndexCompanyRoaster from '../../../rosterManagement/companyRoster/IndexCompanyRoaster';
import IndexCompanyLeaveRequests from '../../../leaveManagement/leave/companyLeaves/IndexCompanyLeaveRequests';
import IndexMyPayslip from '../../../payrollManagement/myPayslips/IndexMyPayslip';
import EmployeePoliciesTab from './EmployeePoliciesTab';
import { CloseOutlined, DeleteOutlined, DownOutlined, DownloadOutlined, EditOutlined, EyeOutlined, FileExcelOutlined, FilePdfOutlined, HistoryOutlined, UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import IndexCompanyLends from '../../../lendManagement/lends/companyLends/IndexCompanyLends';
import { useSelector } from 'react-redux';
import { checkPermissions } from '@comps/commonFunctions';
import "./Employee.css"

const { Content } = Layout;

const ViewEmployee = (props) => {

  //console.log(props);
  //------------use states start----------------
  const [defaultProfileCard, setDefaultProfileCard] = useState();
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState(null)
  const employeeId = props.employee_id
  const [loader, setLoader] = useState(false);
  const [employmentHistoryLoader, setEmploymentHistoryLoader] = useState(false);
  const [employmentHistoryVisible, setEmploymentHistoryVisible] = useState(false);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const canViewPersonal = checkPermissions('profile')
    || ['employeeEmployment', 'employeeAddress', 'employeeContact', 'employeeExperience', 'employeeEducation']
      .some((action) => checkPermissions('profile', action));
  const canViewDocuments = checkPermissions('profile', 'employmentDocuments');
  const canManageDocuments = !!canViewDocuments;
  //-----------end use states--------------------
  useEffect(() => {
    getProfileCardByEmploymentId(props.employment_id);
    // eslint-disable-next-line
  }, [props]);

  const getProfileCardByEmploymentId = (id) => {
    makeRequestStateless(getProfileCardByEmploymentIdReq, { id, showActive: props.showActive }, getProfileCardByEmploymentIdSuccess, null)
    setLoading(true)
    setContent(null)
  }
  const getProfileCardByEmploymentIdSuccess = (response) => {
    setFileList(response.profile_card.profile_pic_url === "images/arnold-avatar.jpg" ? [] : [{
      uid: '-1',
      status: 'done',
      url: withCacheVersion(response.profile_card.profile_pic_url)
    }])
    setDefaultProfileCard(response.profile_card)
    setData()
    setLoading(false)
  }
  const TabContentStyle = { background: 'white' }
  const setData = () => {

    setContent(
      <Content style={ TabContentStyle } >
        <SectionTabs
          className="multi-line-tabs"
          animated={ true }
          destroyInactiveTabPane={ true }
          items={ [
            canViewPersonal && {
              key: 'employeeinfo', label: "Personal",
              children: <UpdateEmployeeInfo id={ employeeId } setDefaultProfileCard={ setDefaultProfileCard } />,
            },
            checkPermissions('profile', 'employeeEmployment') && {
              key: 'employmentinfo', label: "Employment",
              children: <UpdateEmploymentInfo id={ props.employment_id } setDefaultProfileCard={ setDefaultProfileCard } showActive={ props.showActive } />,
            },
            checkPermissions('profile', 'userInformation') && {
              key: 'user', label: "User",
              children: <UpdateUserInfo id={ employeeId } disabled={ false } setDefaultProfileCard={ setDefaultProfileCard } />,
            },
            checkPermissions('profile', 'employmentSalary') && {
              key: 'payroll', label: "Salary",
              children: <UpdatePayrollPolicy id={ props.employment_id } employeeId={ employeeId } disabled={ false } />,
            },
            (checkPermissions('profile', 'employmentSalary') || checkPermissions('myPayslips')) && {
              key: 'payrollPolicyImpact', label: "Policy",
              children: <EmployeePoliciesTab employmentId={ props.employment_id } />,
            },
            checkPermissions('myPayslips') && {
              key: 'payslip', label: "Payslip",
              children: <IndexMyPayslip modkey="myPayslips" employment_id={ props.employment_id } />,
            },
            checkPermissions('profile', 'employeeAddress') && {
              key: 'address', label: "Address",
              children: <IndexAddresses filters={ `employments_|${employeeId}` } employee_id={ employeeId } modkey="employeeAddress" />,
            },
            checkPermissions('profile', 'employeeRelative') && {
              key: 'relatives', label: "Relatives",
              children: <IndexRelatives filters={ `employments_|${employeeId}` } modkey="employeeAddress" />,
            },
            checkPermissions('profile', 'employeeContact') && {
              key: 'contact', label: "Contacts",
              children: <IndexContacts filters={ `employments_|${props.employee_id}` } modkey="employeeContact" />,
            },
            checkPermissions('profile', 'employeeEducation') && {
              key: 'education', label: "Education",
              children: <IndexEducations filters={ `employments_|${employeeId}` } modkey="employeeEducation" />,
            },
            checkPermissions('profile', 'employeeExperience') && {
              key: 'qualification&experiences', label: "Experience",
              children: <IndexExperience filters={ `employments_|${employeeId}` } modkey="employeeExperience" />,
            },
            canViewDocuments && {
              key: 'documents', label: "Documents",
              children: (
                <IndexDocuments
                  filters=""
                  employmentId={ props.employment_id }
                  modkey="employmentDocuments"
                  canManage={ canManageDocuments }
                />
              ),
            },
            // checkPermissions('myRoster') && {
            //   key: 'shifts', label: "Shifts",
            //   children: <IndexCompanyRoaster module='myRoaster' filters={ `employee_|${props.employment_id}` } modkey="myRoster" />,
            // },
            // checkPermissions('myAttendance') && {
            //   key: 'attendance', label: "Attendance",
            //   children: <IndexCompanyTimeSheet filters={ `employee_|${props.employment_id}` } module="my-attendance" modkey="myAttendance" />,
            // },
            // checkPermissions('leaveRequest') && {
            //   key: 'leaves', label: "Leave",
            //   children: <IndexCompanyLeaveRequests module='myLeaveRequest' filters={ `employee_|${props.employment_id};employees_|${props.employment_id}` } modkey="leaveRequest" employment_id={ props.employment_id } />,
            // },
            checkPermissions('profile', 'employeeBank') && {
              key: 'bank', label: "Bank",
              children: <IndexBanks filters={ `employments_|${employeeId}` } modkey="employeeBank" />,
            },


            // checkPermissions('lends') && {
            //   key: 'loans', label: "Loans & Advances",
            //   children: <IndexCompanyLends user={ authUser } filters={ `employee_|${props.employment_id}` } module="my-requests" modkey="lends" />,
            // },
          ].filter(Boolean) }
        />
      </Content>
    )
  }

  //-----------styling------------

  const [fileList, setFileList] = useState([])
  // Photo URL can 404 (deleted/missing file) — fall back to initials instead of a broken image icon.
  const [photoBroken, setPhotoBroken] = useState(false);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });


  const onChange = ({ fileList: newFileList }) => {

    // Update the status of the uploaded file based on the response from your backend
    setPhotoBroken(false);
    setFileList(newFileList.map(file => {
      const optimisticUrl = file.url
        || file.preview
        || (file.originFileObj ? URL.createObjectURL(file.originFileObj) : '');

      if (file.response) {
        // Check if your backend returned a success response
        if (file.response.status === 'success') {
          message.info('Updated Successfully')
          return { ...file, url: optimisticUrl, status: 'done' };
        } else {
          // If your backend returned an error response
          message.error(`File upload failed: ${file.response.message}`);
          return { ...file, url: optimisticUrl, status: 'error' };
        }
      }
      return { ...file, url: optimisticUrl };
    }));
  };

  const beforeUpload = (file) => {
    // Perform any validation or checks before uploading
    return true;
  };

  const uploadPhoto = async ({ file, onSuccess, onError }) => {
    const payload = {
      file: file,
      employeeId: employeeId
    }
    await makeRequestStateless(uploadPhotoReq, payload, () => {
      onSuccess()
      onUpdatedPhoto()
      getProfileCardByEmploymentId(props.employment_id)
    }, onUpdatedPhoto);
  }
  const removePhoto = async () => {
    const payload = {
      file: '',
      employeeId: employeeId
    }
    await makeRequestStateless(uploadPhotoReq, payload, () => {
      setFileList([]);
      onUpdatedPhoto();
      getProfileCardByEmploymentId(props.employment_id);
    }, onUpdatedPhoto);
  }
  const onUpdatedPhoto = (data, res) => {
    props.onCompleted()
    message.info('Updated Successfully')
  }
  const onPreview = async (file) => {

    if ((file.url !== undefined) && (file.extension === 'pdf' || file.type === 'application/pdf')) {
      // Open the PDF file in a new tab
      window.open(file.url, '_blank');
    }
    else {
      if (file.type !== 'application/pdf') {
        // Handle preview for other file types (e.g., images)
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
      }
    }
  };

  //download card
  const downloadEmpCard = (record) => {
    const payload = {
      filters: `download_type_|pdf;ids_|${props.employment_id}`,
    }

    makeRequest(setLoader, downloadEmpCardReq, payload, onDownloadSuccess, onDownloadSuccess);

    //setLoader(true)
  }

  const onDownloadSuccess = (err, res) => {
    // setLoader(false)
    if (res.code === undefined) {
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `employee-card.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
    setLoader(false)
  }


  const downloadReport = (format) => {
    message.info('Downloading...  wait a few seconds.')
    let filters = `employee_|${props.employment_id};`
    const payload = {
      page: 1,
      filters: `${filters}report_id_|${'class_name'},user|${props.employment_id};format_|${format};class_name_|App\\Exports\\EmployeeEmployment\\EmploymentInfoReportExport`,
      employment_id: props.employment_id,
      format: format,
      class_name: 'App\\Exports\\EmployeeEmployment\\EmploymentInfoReportExport'
    }
    //setChildComponent(null)
    makeRequest(setLoader, downloadReportReq, payload, onDownloadReportSuccess, onDownloadReportSuccess);

  }

  const onDownloadFullEmploymentExitReport = () => {
    downloadFullEmploymentExitReport({
      employmentId: props.employment_id,
      joiningDate: defaultProfileCard?.joining_date,
      setLoader,
    });
  }

  const onDownloadReportSuccess = (err, res) => {
    setLoader(false)
    if (res.code === undefined) {
      // Extract file extension
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `Employee_Information_${dayjs().format('YYYY-MM-DD')}.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  const openEmploymentHistory = () => {
    makeRequest(setEmploymentHistoryLoader, getEmploymentHistoryReq, employeeId, onEmploymentHistorySuccess, onEmploymentHistoryError);
  }

  const onEmploymentHistorySuccess = (response) => {
    setEmploymentHistory(response.employment_history || []);
    setEmploymentHistoryVisible(true);
  }

  const onEmploymentHistoryError = (error, response) => {
    message.error(response?.response?.data?.message || 'Unable to fetch employment history.');
  }

  const formatHistoryDate = (date) => {
    return date ? dayjs(date).format('DD MMM YYYY') : '-';
  }

  const historyField = (label, value, className = '') => (
    <div className={ `employment-history-field ${className}` }>
      <span className="employment-history-field__label">{ label }</span>
      <span className="employment-history-field__value">{ value || '-' }</span>
    </div>
  );

  const getHistoryTitle = (history) => {
    const label = history.tenure_label || '';
    return label.replace(/\s*\d+:?$/, '') || 'Employment Tenure';
  }

  const getHistoryCount = (history, index) => {
    return history.tenure_identifier && history.tenure_identifier !== '-'
      ? history.tenure_identifier
      : `#${index + 1}`;
  }
  //----------end styling-----------
  return (
    <div className={ `employee-profile${props.presentation === 'page' ? ' employee-profile--page' : ' employee-profile--drawer'}` }>
      <Spin spinning={ loading }>
        <div className="employee-profile__summary">
          <div className="employee-profile__banner">
            <div className="employee-profile__avatar">
              { fileList[0]?.url && !photoBroken ? (
                <img src={ fileList[0].url } alt="" onError={ () => setPhotoBroken(true) } />
              ) : (
                <span>{ getInitials(defaultProfileCard?.full_name) }</span>
              ) }
              <div className="employee-profile__avatar-actions">
                { fileList[0]?.url ? (
                  <button type="button" onClick={ () => onPreview(fileList[0]) }>
                    <EyeOutlined aria-hidden="true" />
                    <span>View</span>
                  </button>
                ) : null }
                <Upload
                  customRequest={ uploadPhoto }
                  showUploadList={ false }
                  accept=".jpg,.jpeg,.png"
                  onChange={ onChange }
                  beforeUpload={ beforeUpload }
                  multiple={ false }
                >
                  <button type="button">
                    <UploadOutlined aria-hidden="true" />
                    <span>Upload</span>
                  </button>
                </Upload>
                { fileList[0]?.url ? (
                  <button type="button" className="employee-profile__avatar-delete" onClick={ removePhoto }>
                    <DeleteOutlined aria-hidden="true" />
                    <span>Delete</span>
                  </button>
                ) : null }
              </div>
            </div>
            <div className="employee-profile__identity">
              <div className="employee-profile__name">
                { defaultProfileCard?.full_name || '' }
                <Badge status={ defaultProfileCard?.status === 'Active' ? 'success' : 'default' } text={ defaultProfileCard?.status || '' } />
              </div>
              <div className="employee-profile__meta">
                { [defaultProfileCard?.designation_name, defaultProfileCard?.department_name, defaultProfileCard?.line_manager_name ? `Reports to ${defaultProfileCard.line_manager_name}` : null].filter(Boolean).join(' · ') }
              </div>
            </div>
          </div>
          <div className="employee-profile__bar">
            <div className="employee-profile__chips">
              <span>{ defaultProfileCard?.code }</span>
              { defaultProfileCard?.contract_type_name ? <span>{ defaultProfileCard.contract_type_name }</span> : null }
              <span>Joined { defaultProfileCard?.joining_date }</span>
              <span>Profile { defaultProfileCard?.profile_score || 0 }%</span>
            </div>
            {/* { canViewPersonal ? (
            <Button
              className="employee-profile__edit"
              type="primary"
              icon={ <EditOutlined /> }
              onClick={ () => document.querySelector('.employee-profile .edit-button')?.click() }
            >
              Edit Profile
            </Button>
          ) : null } */}
            <div className="employee-profile__actions">
              <Button icon={ <HistoryOutlined /> } onClick={ openEmploymentHistory } loading={ employmentHistoryLoader }>
                History
              </Button>
              <Button icon={ <DownloadOutlined /> } disabled={ loader } onClick={ () => downloadEmpCard() } >
                Download Card
              </Button>
              <Dropdown
                trigger={ ['click'] }
                menu={ {
                  items: [
                    { key: 'xlsx', icon: <FileExcelOutlined className="text-success" />, label: 'Export to Excel' },
                    { key: 'pdf', icon: <FilePdfOutlined className="text-danger" />, label: 'Export to PDF' },
                    { key: 'full-employment-exit-report', icon: <FileExcelOutlined className="text-success" />, label: 'Full Employment & Exit Report' },
                  ],
                  onClick: ({ key }) => key === 'full-employment-exit-report' ? onDownloadFullEmploymentExitReport() : downloadReport(key),
                } }
              >
                <Button type="primary" disabled={ loader }>
                  Export info <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>
      </Spin>


      <Layout className="employee-profile__tabs-layout">

        <Layout hasSider>
          { content }
        </Layout>
      </Layout>

      <ModalComponent width={ 1000 } open={ previewOpen } title={ defaultProfileCard ? defaultProfileCard.full_name : '' } footer={ null } onCancel={ handleCancel }>
        <div style={ {
          textAlign: 'center',
          padding: 100,
          paddingTop: 0
        } }>
          <img
            alt=""
            style={ {
              width: '50%',
            } }
            src={ previewImage }
          />
        </div>
      </ModalComponent>

      <Modal
        className="employment-history-modal"
        width={ 900 }
        open={ employmentHistoryVisible }
        title={
          <span className="employment-history-modal__title">
            Employment History
          </span>
        }
        footer={ null }
        closeIcon={ <span className="employment-history-modal__close"><CloseOutlined /></span> }
        onCancel={ () => setEmploymentHistoryVisible(false) }
      >
        <Spin spinning={ employmentHistoryLoader }>
          { employmentHistory.length === 0 ? (
            <div className="employment-history-empty">No employment history found.</div>
          ) : (
            <div className="employment-history-list">
              { employmentHistory.map((history, index) => (
                <div className="employment-history-card" key={ history.id || index }>
                  <div className="employment-history-card__header">
                    <div className="employment-history-card__heading">
                      <strong>{ getHistoryTitle(history) }</strong>
                      { history.is_active && <span className="employment-history-current">Current</span> }
                    </div>
                    <span className="employment-history-card__count">
                      { getHistoryCount(history, index) }
                    </span>
                  </div>
                  <div className="employment-history-card__divider" />
                  <div className="employment-history-grid">
                    { historyField('Joining Date', formatHistoryDate(history.joining_date)) }
                    { historyField('Leaving Date', formatHistoryDate(history.end_of_employment?.last_working_date || history.end_of_employment?.resignation_date), !history.end_of_employment ? 'employment-history-field--muted' : '') }
                    { historyField('Department', history.department?.name) }
                    { historyField('Designation', history.designation?.name) }
                    { historyField('Branch', history.branch?.name) }
                    { historyField('Location', history.location?.name) }
                    { historyField('Employee Type', history.employee_type?.name) }
                    { historyField('Contract Type', history.contracttype?.name) }
                    <div className="employment-history-field">
                      <span className="employment-history-field__label">Status</span>
                      <span className={ `employment-history-status ${history.is_active ? 'employment-history-status--active' : 'employment-history-status--inactive'}` }>
                        <span className="employment-history-status__dot" />
                        { history.is_active ? 'Active' : 'Inactive' }
                      </span>
                    </div>
                    { historyField('Reason', history.end_of_employment?.reason?.name) }
                  </div>
                </div>
              )) }
            </div>
          ) }
        </Spin>
      </Modal>
    </div>
  );

};
export default ViewEmployee;

// Same initials rules as the employee card grid (IndexEmployees.jsx)
const getInitials = (name = '') => {
  // Strip employee-code suffixes like "- (Ch-00006)" / "(0164)" and any non-letters
  // so names such as "ASGHAR ABBAS - (Ch-00006)" don't produce garbage like "A(".
  const parts = String(name)
    .replace(/\(.*?\)/g, ' ')
    .replace(/[-–—].*$/, ' ')
    .replace(/[^A-Za-z\s]/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const withCacheVersion = (url = '') => {
  if (!url) return '';
  return `${url}${url.includes('?') ? '&' : '?'}v=${Date.now()}`;
};
